module.exports = __webpack_public_path__ + "img/36.b53610a7.png";